import { render, staticRenderFns } from "./SplitDetail.vue?vue&type=template&id=2b6e2d72&scoped=true"
import script from "./SplitDetail.vue?vue&type=script&lang=js"
export * from "./SplitDetail.vue?vue&type=script&lang=js"
import style0 from "./SplitDetail.vue?vue&type=style&index=0&id=2b6e2d72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6e2d72",
  null
  
)

export default component.exports